<template>
  <div class="ten-date-header">
    <ten-button
      class="ten-date-header__btn ten-date-header__btn--prev-year"
      type="text"
      size="small"
      icon="double_left"
      @click="$emit('btn-click', 'double', -1)"
    />

    <ten-button
      class="ten-date-header__btn ten-date-header__btn--prev-month"
      type="text"
      size="small"
      icon="left"
      @click="$emit('btn-click', 'single', -1)"
    />

    <slot>
      <div class="ten-date-header__text">
        <template v-if="type === 'year'">
          <span>
            {{ startYear }}
          </span>
          -
          <span>
            {{ startYear + 9 }}
          </span>
        </template>

        <ten-button
          v-show="type !== 'year'"
          class="ten-date-header__btn"
          type="text"
          size="small"
          @click="$emit('update:type', 'year')"
        >
          {{ year + ' 年' }}
        </ten-button>

        <ten-button
          v-show="type === 'date'"
          class="ten-date-header__btn"
          type="text"
          size="small"
          @click="$emit('update:type', 'month')"
        >
          {{ (month === 12 ? 1 : month + 1) + ' 月' }}
        </ten-button>
      </div>
    </slot>

    <ten-button
      class="ten-date-header__btn ten-date-header__btn--next-month"
      type="text"
      size="small"
      icon="right"
      @click="$emit('btn-click', 'single', 1)"
    />

    <ten-button
      class="ten-date-header__btn ten-date-header__btn--next-year"
      type="text"
      size="small"
      icon="double_right"
      @click="$emit('btn-click', 'double', 1)"
    />
  </div>
</template>

<script>
import TenButton from '../../button';

export default {
  components: {
    TenButton,
  },
  props: {
    year: Number,
    month: Number,
    type: {
      type: String,
      default: 'date',
      validator: v => ['year', 'month', 'date'].indexOf(v) > -1,
    },
  },
  computed: {
    startYear() {
      return parseInt(this.year / 10, 10) * 10;
    },
  },
};
</script>
